import "./Services.css";

const SERVICES = [
  {
    icon: "/assets/our-services/ac-installation.png",
    title: "AC Installation",
    desc: "Professional split & inverter AC installation with proper mounting and testing.",
  },
  {
    icon: "/assets/our-services/ac-repair.png",
    title: "AC Repair",
    desc: "Fast diagnosis and repair for cooling issues, leaks, and electrical faults.",
  },
  {
    icon: "/assets/our-services/ac-maintenance.png",
    title: "AC Maintenance",
    desc: "Regular servicing to keep your AC efficient and extend its lifespan.",
  },
  {
    icon: "/assets/our-services/ac-gas-filling.png",
    title: "AC Gas Filling",
    desc: "Refrigerant top-up and leak detection for optimal cooling performance.",
  },
  {
    icon: "/assets/our-services/ac-duct-cleaning.png",
    title: "AC Duct Cleaning",
    desc: "Deep cleaning of filters, coils, and ducts for fresh, healthy air.",
  },
  {
    icon: "/assets/our-services/emergency-ac-support.png",
    title: "Emergency AC Support",
    desc: "Urgent AC breakdowns handled quickly available across Kamra & Attock.",
  },
];

export default function Services() {
  return (
    <section className="services" id="services">
      <div className="container">
        <span className="section-label">Our Services</span>
        <h2 className="section-title">Complete AC Solutions</h2>
        <p className="section-subtitle">
          From installation to emergency repairs trusted technician services
          for homes and businesses in Kamra and Attock.
        </p>

        <div className="services-grid">
          {SERVICES.map((service) => (
            <article key={service.title} className="service-card">
              <div className="service-icon-wrap">
                <img
                  src={service.icon}
                  alt=""
                  className="service-icon-img"
                  loading="lazy"
                />
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
